export default function getCountry(locale: string) {
  return locale?.split('-')[1] || ''
}
